import React from 'react';
import { Link } from 'react-router-dom';
import { formatTextsCallsTile } from '../../utils/textsCallsTile';

export default function TextsCallsTile({ smsNumber, activity, wallet }) {
  const view = formatTextsCallsTile({ smsNumber, activity, wallet });

  return (
    <section className="today-panel texts-calls-tile" aria-label="Texts and calls">
      <div className="today-panel-header">
        <h2 className="today-panel-title">Texts &amp; calls</h2>
      </div>
      <div className="texts-calls-grid">
        <Link to={view.textsHref} className="texts-calls-metric">
          <span className="today-stat-label">{view.textsLabel}</span>
          <span className="today-stat-value">{view.textsValue}</span>
        </Link>
        <Link to={view.textsHref} className="texts-calls-metric">
          <span className="today-stat-label">{view.missedLabel}</span>
          <span className="texts-calls-sub">{view.missedSub}</span>
          <span className="today-stat-value">{view.missedValue}</span>
        </Link>
        <Link to={view.textsHref} className="texts-calls-metric">
          <span className="today-stat-label">{view.optedOutLabel}</span>
          <span className="today-stat-value">{view.optedOutValue}</span>
        </Link>
        <Link to={view.walletHref} className="texts-calls-metric">
          <span className="today-stat-label">{view.walletLabel}</span>
          <span className="today-stat-value">{view.walletValue}</span>
          {view.lowBalance && (
            <span className="texts-calls-warn">{view.lowBalanceLabel}</span>
          )}
          <span className="texts-calls-sub">{view.autoRechargeLabel}</span>
        </Link>
      </div>
    </section>
  );
}
